import { useSyncExternalStore } from 'react';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';

import { clearLocalStorage } from '../common/storage';
import { clearAuthTokenData } from '../common/token';
import { userStore } from '../common/userStore';
import { self } from '../../shared/service/auth';

import { SelfData } from '../../shared/constants/user';
import useFetch from './useFetch';

export default function useAuth() {
  const user = useSyncExternalStore(userStore.subscribe, userStore.get);
  const navigate = useNavigate();

  const invalidateUser = () => {
    navigate('/login');
    clearAuthTokenData();
    userStore.clear();
    clearLocalStorage();
  };

  const {
    data: selfData,
    refetch: refreshUser,
    isLoading: loadingSelf,
  } = useFetch<AxiosResponse<SelfData>>(['selfAuth'], () => self(), {
    enabled: false,
    onSuccess: (response: any) => {
      userStore.set(response?.data);
    },
    onError: () => {},
  });

  return {
    user,
    invalidateUser,
    loadingSelf,
    refreshUser,
    selfData,
  };
}
